import api from "./api";

export interface FolhaColaboradorDto {
  id: number;
  siengeId: number;
  nome: string;
  documento: string;
  createdAt: string;
  updatedAt: string;
}

export interface SiengeColaboradorOption {
  id: number;
  name: string;
  documentNumber: string;
  active: boolean;
}

const BASE_URL = "/api/folha-pagamentos/colaboradores";

export async function listFolhaColaboradores(): Promise<FolhaColaboradorDto[]> {
  const { data } = await api.get<{ success: boolean; colaboradores: FolhaColaboradorDto[] }>(
    BASE_URL,
  );
  return data.colaboradores;
}

export async function listSiengeColaboradores(opts?: {
  q?: string;
  refresh?: boolean;
}): Promise<SiengeColaboradorOption[]> {
  const params: Record<string, string> = {};
  if (opts?.q?.trim()) params.q = opts.q.trim();
  if (opts?.refresh) params.refresh = "1";
  const { data } = await api.get<{
    success: boolean;
    colaboradores: SiengeColaboradorOption[];
  }>(`${BASE_URL}/sienge`, { params });
  return data.colaboradores;
}

export async function createFolhaColaborador(siengeId: number): Promise<FolhaColaboradorDto> {
  const { data } = await api.post<{ success: boolean; colaborador: FolhaColaboradorDto }>(
    BASE_URL,
    { siengeId },
  );
  return data.colaborador;
}

export async function deleteFolhaColaborador(id: number): Promise<void> {
  await api.delete(`${BASE_URL}/${encodeURIComponent(String(id))}`);
}
